import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LogoutButton from './LogoutButton';

const RedirectManager = () => {
  const { affaireId } = useParams();
  const [redirectPath, setRedirectPath] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadRedirects() {
      try {
        // Charger le fichier de configuration des redirections
        const response = await fetch('/reports/config/redirects.json');
        
        if (!response.ok) {
          throw new Error('Impossible de charger les redirections');
        }
        
        const redirects = await response.json();
        
        // Vérifier si l'ID d'affaire existe dans les redirections
        if (redirects[affaireId]) {
          setRedirectPath(redirects[affaireId]);
        } else {
          setError(`Aucun rapport disponible pour l'affaire: ${affaireId}`);
        }
      } catch (err) {
        setError(`Erreur lors du chargement des redirections: ${err.message}`);
      } finally {
        setLoading(false);
      }
    }

    loadRedirects();
  }, [affaireId]);

  // Effet pour effectuer la redirection
  useEffect(() => {
    if (redirectPath) {
      // Redirection vers l'URL cible
      window.location.href = redirectPath;
    }
  }, [redirectPath]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Chargement du rapport {affaireId}...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
        <div className="max-w-md w-full p-8 bg-white rounded-xl shadow-lg">
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded mb-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                {error}
              </div>
            </div>
          </div>
          <div className="flex justify-center mt-4">
            <LogoutButton />
          </div>
        </div>
      </div>
    );
  }

  // État pendant la redirection
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">Redirection en cours...</p>
      </div>
    </div>
  );
};

export default RedirectManager;